import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  page: number;
  totalPages: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
}

export function Pagination({
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
}: PaginationProps) {
  const from = Math.min((page - 1) * pageSize + 1, total);
  const to = Math.min(page * pageSize, total);

  // Build visible page numbers with ellipsis
  const pages: (number | '...')[] = [];
  if (totalPages <= 5) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push('...');
    for (
      let i = Math.max(2, page - 1);
      i <= Math.min(totalPages - 1, page + 1);
      i++
    ) {
      pages.push(i);
    }
    if (page < totalPages - 2) pages.push('...');
    pages.push(totalPages);
  }

  const btn =
    'flex h-7 w-7 items-center justify-center rounded-sm text-xs transition-colors';

  return (
    <div className="flex items-center justify-between py-3 text-xs">
      <span className="text-subtle">
        Showing {from}–{to} of {total} tenants
      </span>
      <div className="flex items-center gap-2">
        <button
          className={`${btn} text-subtle bg-bg-elevated`}
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft size={20} />
        </button>
        {pages.map((p, i) =>
          p === '...' ? (
            <span key={`ellipsis-${i}`} className="text-subtle px-1">
              …
            </span>
          ) : (
            <button
              key={p}
              className={`${btn} ${p === page ? 'bg-[#5E6AD2] text-white' : 'text-subtle hover:bg-white/6'}`}
              onClick={() => onPageChange(p as number)}
            >
              {p}
            </button>
          ),
        )}
        <button
          className={`${btn} text-subtle bg-bg-elevated`}
          disabled={page === totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRight size={20} />
        </button>
      </div>
    </div>
  );
}
